import { render, staticRenderFns } from "./TemplateInfo.vue?vue&type=template&id=17b9bc2b&scoped=true"
import script from "./TemplateInfo.vue?vue&type=script&lang=js"
export * from "./TemplateInfo.vue?vue&type=script&lang=js"
import style0 from "./TemplateInfo.vue?vue&type=style&index=0&id=17b9bc2b&prod&lang=css"
import style1 from "./TemplateInfo.vue?vue&type=style&index=1&id=17b9bc2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b9bc2b",
  null
  
)

export default component.exports